import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['button']
  copy() {
    navigator.clipboard.writeText(this.data.get('text'));
    this.buttonTarget.innerText = 'Copied!'
  }
}
